var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3b727693ce15c9588d1f1280c93a94682489356c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["rockalingua-web@rockalingua"]={id:"3b727693ce15c9588d1f1280c93a94682489356c"};
      